import {makeStyles} from '@material-ui/core/styles'
import {useNavigate, useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import Paper from '@mui/material/Paper'
import Services from '../../../components/3modules/AccountImport/Services'

const ApproveClientForm = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const id = useParams().id
    const [selectedClient, setSelectedClient] = useState(null)

    const onCancel = () => {
        navigate(`/adminDashboard`)
    }

    const onNext = () => {
        navigate(`/approveService/newService/${id}`)
    }


    useEffect(()=>{
        const selectedClientFromStorage = getItemFromSessionStorage('selectedClient')
        if(selectedClientFromStorage){
            setSelectedClient(selectedClientFromStorage)
        }
    }, [])

    return (
        <Paper className={classes.root}>
            <Services selectedClient={selectedClient} setSelectedClient={setSelectedClient} onNextService={onNext}
                      disabled onCancel={onCancel} />
        </Paper>
    )
}

export default ApproveClientForm

const useStyles = makeStyles({
    root: {
        margin: '20px',
        marginLeft: '80px',
        padding: '20px',
        width: '100%'
    }
})
